import './external-scripts-loader'
import posthog from './module.slim.no-external.es'
export * from './module.slim.no-external.es'
export default posthog
